import { gql } from '@apollo/client';
import { textPairFragment, apiResponseFragment } from '../../query/fragments';

// Query for TMNT text pairs (global data that can be cached across users)
export const CHANGE_PASSWORD_FORM_QUERY = gql`
query CHANGE_PASSWORD_FORM_QUERY {
  textFor {
    changePasswordHeadingText: pair(pairKey: "changePasswordHeading") {...textPair}
    createNewPasswordText: pair(pairKey: "createPasswordPaneInstructions") {...textPair}
    saveButtonText: pair(pairKey: "save") {...textPair}
    passwordReqNoteText: pair(pairKey: "passwordCharacterLength") {...textPair}
    keepMeSignedInCheckboxTooltipText: pair(pairKey: "keepMeSignedInCheckboxTooltip") {...textPair}
    keepMeSignedInCheckboxText: pair(pairKey: "keepMeSignedIn") {...textPair}
    currentPasswordText: pair(pairKey: "currentPassword") {...textPair}
    newPasswordText: pair(pairKey: "newPassword") {...textPair}
    confirmPasswordText: pair(pairKey: "confirmPassword") {...textPair}
    showPasswordText: pair(pairKey: "showPassword") {...textPair}
    hidePasswordText: pair(pairKey: "hidePassword") {...textPair}
    processing: pair(pairKey: "processing") { ...textPair }
    success: pair(pairKey: "success") { ...textPair }
    pleaseTryAgain: pair(pairKey: "pleaseTryAgain") { ...textPair }
    newPasswordMatchError: pair(pairKey: "newPasswordMatchError") {...textPair}
    invalidInputError: pair(pairKey: "invalidInputError") {...textPair}
    keepMeSignedInTooltipLabel: pair(pairKey: "keepMeSignedInTooltipLabel") {...textPair}
    invalidCurrentPasswordError: pair(pairKey: "invalidCurrentPasswordError") {...textPair}
  }
}

${textPairFragment}
`;

// Query for password strength feature flag (global data that can be cached across users)
export const PASSWORD_STRENGTH_FEATURE_FLAG_QUERY = gql`
query PASSWORD_STRENGTH_FEATURE_FLAG_QUERY {
  isPasswordStrengthEnabled: featureFlag(
    key: "is-password-strength-meter-enabled"
  ),
}
`;

export const changePasswordRequest = gql`
  mutation ChangePassword($currentPassword: String!, $newPassword: String!, $keepMeSignedIn: Boolean) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword, keepMeSignedIn: $keepMeSignedIn) {
      ...response
    }
  }

  ${apiResponseFragment}
`;
